export const ENDPOINT_MESSAGE_RECEIVED_COLLAB_IMAGES_IMAGE_ID = 'collab-images/image-id';
export const ENDPOINT_MESSAGE_RECEIVED_TAKE_CAPTURE_OF_PARTICIPANT = 'collab-images/take-capture-of-participant';
export const ENDPOINT_MESSAGE_RECEIVED_CAPTURE_RESULT = 'collab-images/capture-result';
export const ENDPOINT_MESSAGE_REMOVE_IMAGE = 'collab-images/remove-image';
